import { useTranslation } from 'react-i18next';

import type { Message } from '../viewmodels/messages';

export type Labels = {
  errorMessage: string;
  retry: string;
  loading: string;
  loadError: string;
  notFound: string;
  missingContext: string;
  sectionsRailTitle: string;
  sectionsRailLabel: string;
  questionsHeading: string;
  responseTypeHeading: string;
  formatMessage: (message: Message) => string;
};

export function useLabels(): Labels {
  const { t } = useTranslation();

  return {
    errorMessage: t('web.admin.inspections.templateCustomize.v2.errorMessage'),
    retry: t('web.admin.inspections.templateCustomize.v2.retry'),
    loading: t('web.admin.inspections.templateCustomize.v2.loading'),
    loadError: t('web.admin.inspections.templateCustomize.v2.loadError'),
    notFound: t('web.admin.inspections.templateCustomize.v2.notFound'),
    missingContext: t(
      'web.admin.inspections.templateCustomize.v2.missingContext'
    ),
    sectionsRailTitle: t(
      'web.admin.inspections.templateCustomize.v2.sectionsRailTitle'
    ),
    sectionsRailLabel: t(
      'web.admin.inspections.templateCustomize.v2.sectionsRailLabel'
    ),
    questionsHeading: t(
      'web.admin.inspections.templateCustomize.v2.questionsHeading'
    ),
    responseTypeHeading: t(
      'web.admin.inspections.templateCustomize.v2.responseTypeHeading'
    ),
    formatMessage: ({ key, params }) => t(key, params),
  };
}
